import { render, staticRenderFns } from "./PopularQueriesSettings.vue?vue&type=template&id=5bd909e9"
import script from "./PopularQueriesSettings.vue?vue&type=script&lang=js"
export * from "./PopularQueriesSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports